import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useCurrentPageData from '../../../../modules/react/hooks/useCurrentPageData';
import useCurrentSite from '../../../../modules/react/hooks/useCurrentSite';
import styles from './styles.scss';

const getCategoryRoute = ({ slug }) => {
  if (!slug) {
    return '/blog';
  }

  return `/blog/category/${slug}`;
};

// If we're on a category page, we want to highlight that category in the list.
const getCategoryStyle = ({ slug }, pageSlug, primaryColor) => {
  if (!slug || pageSlug !== `blog/category/${slug}`) {
    return null;
  }

  return { color: primaryColor };
};

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string,
  })).isRequired,
};

const defaultProps = {};

const BlogCategories = ({ categories }) => {
  const { slug: pageSlug } = useCurrentPageData();
  const { theme } = useCurrentSite();
  const { colors: { primary: primaryColor } } = theme;

  return (
    <div>
      <div className={styles.header} style={{ color: primaryColor }}>Categories</div>
      {categories && categories.map(category => (
        <div className={styles.category}>
          <a
            className={styles.link}
            href={getCategoryRoute(category)}
            style={getCategoryStyle(category, pageSlug, primaryColor)}
          >
            {category.name}
          </a>
        </div>
      ))}
    </div>
  );
};

BlogCategories.propTypes = propTypes;
BlogCategories.defaultProps = defaultProps;

BlogCategories.fragments = {
  blogCategories: gql`
    fragment BlogCategoriesBlogCategories on BlogCategory {
      name
      slug
    }
  `,
};

export default BlogCategories;
